<template>
	<router-view />
</template>

<script>
export default {
	name: "Dailydata"
};
</script>

<style lang="scss">
@import "~@/scss/styles";
</style>
